import CreateForm, { CreateFormOptions } from './CreateForm';

export type { CreateFormOptions };

export default CreateForm;
